import moment from 'moment'

// The short age label posts wear: seconds, then minutes, then hours, then a
// calendar date. Extracted from UserName so any surface quoting a post ages it
// the same way the post's own byline does — a quote reading "2h" while the
// message it quotes reads "3h" is a bug the reader can see.
export function formatRelativeTimeLabel(createdAt: string | number | Date | null | undefined) {
    if (!createdAt) return ''
    if (createdAt === 'now') return 'now'

    const momentCreatedAt = moment(createdAt)
    if (!momentCreatedAt.isValid()) return ''

    const now = moment()
    const diffSeconds = now.diff(momentCreatedAt, 'seconds')
    const diffMinutes = now.diff(momentCreatedAt, 'minutes')
    const diffHours = now.diff(momentCreatedAt, 'hours')

    // Less than a minute ago: show seconds
    if (diffSeconds < 60) {
        return `${diffSeconds}s`
    }
    // Less than an hour ago: show minutes
    if (diffMinutes < 60) {
        return `${diffMinutes}m`
    }
    // Less than a day ago: show hours
    if (diffHours < 24) {
        return `${diffHours}h`
    }

    // If it's this year, show "MMM D" (e.g., "Feb 10")
    if (momentCreatedAt.year() === now.year()) {
        return momentCreatedAt.format('MMM D')
    }

    // If it's a different year, show "MMM D, YYYY" (e.g., "Feb 10, 2024")
    return momentCreatedAt.format('MMM D, YYYY')
}
